module.exports = __webpack_public_path__ + "static/media/81MCD0w9RNL._AC_SL1500_.8d71a1f9.jpg";